import { registerPageInit } from '../barba/page-init-registry';
import { initActivityPageBreadcrumb } from '../utils/activity-page-breadcrumb';
import { refreshEventStatusLabels } from '../utils/event-status';
import { initShareButtons } from '../utils/share-buttons';
import '../../css/_root.scss';
import '../../css/pages/news/index.scss';

function initEventDetailPage(): void {
  initActivityPageBreadcrumb();
  refreshEventStatusLabels();
  initShareButtons();
}

registerPageInit('event-detail', initEventDetailPage);
registerPageInit('news-activity-page', initEventDetailPage);
